import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import "./index.css";

interface IProps {
  className?: string;
  checked: boolean;
  onChange: (skipBlank: boolean) => void;
  size?: string;
}

const MySwitch: React.FC<IProps> = ({ className, checked, onChange, size = 'default' }) => {
  return <Switch className={`my-switch ${size === 'small' && 'my-switch-small' } ${className}`} checked={checked} onChange={onChange} />;
};

export default MySwitch;
